import(/* webpackMode: "eager" */ "/vercel/path0/app/(main)/terms/page.tsx");
